import { Component, Input, OnInit } from '@angular/core';
import { trigger, state, style, transition, animate, useAnimation, animation, keyframes } from '@angular/animations';
import { fadeIn, fadeOut, slideIn, slideOut } from '../carousel-animations';

@Component({
  selector: 'adc-carousel',
  templateUrl: './adc-carousel.component.html',
  styleUrls: ['./adc-carousel.component.scss'],
  standalone: false,
  animations: [
    trigger("slideAnimation", [
      /* fade */
      transition("void => fade", [
        useAnimation(fadeIn, { params: { time: "500ms" } })
      ]),
      transition("fade => void", [
        useAnimation(fadeOut, { params: { time: "500ms" } })
      ]),

      /* slide */
      transition("void => slide", [
        useAnimation(slideIn, { params: { start: '100%'} })
      ]),
      transition("slide => void", [
        useAnimation(slideOut, { params: { end: '100%' } })
      ])
    ])
  ]
})
export class AdcCarouselComponent implements OnInit{
  // @Input('type') type!: string;
  @Input('data') data: any;
  currentIndex = 0;
  currentSlides: number[] = [];

  ngOnInit() {
    this.data.forEach((_ : any) => this.currentSlides.push(0));
  }

  onPreviousClick(index: number) {
    const previous = this.currentSlides[index] - 1;
    this.currentSlides[index] = previous < 0 ? this.data[index].image.length - 1 : previous;
  }
  
  onNextClick(index: number) {
    const next = this.currentSlides[index] + 1;
    this.currentSlides[index] = next === this.data[index].image.length ? 0 : next;
  }

  navTo(index: any) {
    this.currentIndex = index;
  }
}
